import React, { Component } from 'react'
import logo from './../Images/gfsoft_small.svg'
import {Link} from 'react-router-dom'
import AutoComplete from './../Function/AutoComplete';

class Header extends Component {

    constructor(props) {
        super(props)
        this.handleSortir = this.handleSortir.bind(this)
    }

    handleSortir(sort) {
        this.props.history.push(this.props.urlparamssortir+'&sort='+sort)
        
        window.scrollTo(0, 0)
    }
    
    render() {
        const { sort } = this.props
        var rendersortir
        if("false"!==this.props.showsortir){
            rendersortir = (
                <>
                    Urut berdasarkan: 
                    <button onClick={() => this.handleSortir('popular')} className={("popular"===sort) ? "active" : ""}>Popular</button>
                    <button onClick={() => this.handleSortir('terbaru')} className={("terbaru"===sort) ? "active" : ""}>Terbaru</button>
                    <button onClick={() => this.handleSortir('terbantu')} className={("terbantu"===sort) ? "active" : ""}>Terbantu</button>
                    {
                        (""!==this.props.keyword) ?
                        <button onClick={() => this.handleSortir('terkait')} className={("terkait"===sort || ""===sort) ? "active" : ""}>Terkait</button>    
                        : ''
                    }
                </>
            )
        }
        
        return (
            <div className="header">
                <div className="header-left">
                    <Link to={"/"}>
                        <span className="esupport" title="e-Support GFSOFT"></span>&nbsp;
                        <img src={logo} alt="GFSOFT" title="e-Support GFSOFT"/>
                    </Link>
                </div>
                <div className="header-right">
                    <div className="searchfield">
                        <AutoComplete {...this.props}/>
                        <div className="sortir">
                            {rendersortir}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Header